import { render } from "./App.vue?vue&type=template&id=1c105da4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Trinity_Projects\\cesp_skuuni_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__